<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="dedication_1"></a><p class="ded">TO BILL AND SYDNEY</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ItalianLover_dedi_1.vue?8b5c0736